import ArticleRDW from './ArticleRDW';

export default ArticleRDW;
